import { TagColor } from '../data/tag.model';

export interface TagColorConfig {
  solidClass: string;
  outlineClass: string;
  badgeColorName: string;
}

export const TAG_COLOR_CONFIG: Record<TagColor, TagColorConfig> = {
  amber: { solidClass: 'bg-amber-500', outlineClass: 'outline-amber-500', badgeColorName: 'amber' },
  red: { solidClass: 'bg-red-500', outlineClass: 'outline-red-500', badgeColorName: 'red' },
  indigo: { solidClass: 'bg-indigo-500', outlineClass: 'outline-indigo-500', badgeColorName: 'indigo' },
  teal: { solidClass: 'bg-teal-500', outlineClass: 'outline-teal-500', badgeColorName: 'teal' },
  orange: { solidClass: 'bg-orange-500', outlineClass: 'outline-orange-500', badgeColorName: 'orange' },
  purple: { solidClass: 'bg-purple-500', outlineClass: 'outline-purple-500', badgeColorName: 'purple' },
  green: { solidClass: 'bg-green-500', outlineClass: 'outline-green-500', badgeColorName: 'green' },
  pink: { solidClass: 'bg-pink-500', outlineClass: 'outline-pink-500', badgeColorName: 'pink' },
};
